import { ebookConstants } from '../constants/ebook.constant';
import { generateUtmExt, log } from '../../common/common';
import { logoutUser } from './login.action';
import axiosInstance from '../helper/axiosInstance';

const fetchEbooksSuccess = (payload) => {
  return {
    type: ebookConstants.GET_EBOOKS_SUCCESS,
    payload
  };
};
const fetchEbooksFailure = (payload) => {
  return {
    type: ebookConstants.GET_EBOOKS_FAILURE,
    payload
  };
};
const fetchEbookDetailsSuccess = (payload) => {
  return {
    type: ebookConstants.GET_EBOOK_DETAILS_SUCCESS,
    payload
  };
};
const fetchEbookDetailsFailure = (payload) => {
  return {
    type: ebookConstants.GET_EBOOK_DETAILS_FAILURE,
    payload
  };
};
export const fetchEbooks = (pagination_limit, callback, spec = '') => {
  return async (dispatch) => {
    axiosInstance
      .get(`epub/listing?from=${pagination_limit}&to=10${spec}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(fetchEbooksSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(fetchEbooksFailure(error));
      });
  };
};

export const fetchEbookDetails = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`epub/detail?type_id=${id}${generateUtmExt()}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(fetchEbookDetailsSuccess(response.data));
        }
      })
      .catch((error) => {
        log('error', error);
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
        dispatch(fetchEbookDetailsFailure(error));
      });
  };
};

export const fetchEbookPages = (id, offset, limit, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`epub/mobileview?id=${id}&from=${limit}&to=${offset}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        log('error', error);
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
      });
  };
};
export const fetchEbookPagesCount = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`epub/mobileviewcount?id=${id}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        log('error', error);
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
      });
  };
};
